import { reactive } from 'vue';

export const authority = reactive({});

const deleteAuthority = () => {
    Object.keys(authority).forEach((key) => {
        delete authority[key];
    });
};

// 项目ID对应权限
const projectIdToAuthority = {
    // 天龙
    5: '/draco_all_bom',
    // 全自动天鹅
    6: '/fully_automatic_swan_all_bom',
    // 天鸽
    7: '/columba_all_bom',
    // 半自动天鹅
    8: '/semi_automatic_swan_all_bom',
    // 半自动天鹤
    9: '/semi_automatic_crane_all_bom',
};

// 根据项目ID获取到对应的Key 返回authority中的权限
export const getBomAuthorityByProjectId = (id) => {
    const authorityKey = projectIdToAuthority[id];

    if (!authorityKey) return false;

    return Boolean(authority[authorityKey]);
};

export const setAuthority = (data) => {
    deleteAuthority();
    Object.keys(data).forEach((key) => {
        authority[key] = data[key];
    });
};
